import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames/bind';
import Preview from '../Preview/Preview';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const Layout = ({ children, preview, userId }) => (
  <>
    <main className={styles.main}>
      { children }
      { preview && (
        <Preview userId={userId} />
      ) }
    </main>
    <footer className={cx(styles.footer, { preview })}>
      <div>
        <span>© Jobox. All rights reserved.</span>
      </div>
    </footer>
  </>
);

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  preview: PropTypes.bool,
  userId: PropTypes.number,
};

export default Layout;
